var CalendarBase = require("./CalendarBase");

/**
 * The CalendarDate class represents a date/datetime/time data type.
 * It handles the formatting and accepts several options like
 * calendar, a custom format string and a subtype.
 *
 * @param {Object} [oConfig] A configuration object that is used to specify the formatting
 * @constructor
 */
function CalendarTime(oConfig) {
	CalendarBase.call(this, oConfig);

	this.utc = true;
}

CalendarTime.prototype = Object.create(CalendarBase.prototype);
CalendarTime.prototype.constructor = CalendarTime;

/**
 * Returns the value of the given property that is assigned in the line item.
 *
 * @param {string} sProperty Name of the property that contains the value
 * @param {Object} oData Line item that contains data
 * @return {number|null} XLSX specific date/time format in days since 30.12.1899
 */
CalendarTime.prototype.getValue = function(sProperty, oData) {
	var iExcelTimestamp;

	iExcelTimestamp = Object.getPrototypeOf(CalendarTime.prototype).getValue.call(this, sProperty, oData);

	/* Remove date specific part to only represent time */
	return typeof iExcelTimestamp === "number" ? iExcelTimestamp % 1 : null;
};

/**
 * Returns the default NumberFormat for the specific type.
 *
 * @returns {string} NumberFormat template for type DateTime
 * @private
 */
CalendarTime.prototype.getDefaultFormat = function() {
	return Object.getPrototypeOf(CalendarTime.prototype).getDefaultFormat.call(this)
		|| CalendarBase.BUILTIN[21];
};

/**
 * Converts a textual date/time representation to a numeric timestamp.
 *
 * @param {string} sValue String representation of the date/time
 * @return {number|null} Numeric timestamp
 * @private
 */
CalendarTime.prototype._parseStringValue = function(sValue) {
	var fParsedValue;

	fParsedValue = Object.getPrototypeOf(CalendarTime.prototype)._parseStringValue.call(this, sValue);

	if (typeof fParsedValue === "number") {
		return fParsedValue;
	}

	/* 2. OData Edm.TimeOfDay */
	if (CalendarBase.timeOfDayRegex.test(sValue)) {
		return CalendarBase._parseTimeOfDay(sValue);
	}

	/* 3. OData duration string "PT01H23M45S" */
	if (CalendarBase.odataDurationRegex.test(sValue)) {
		return CalendarBase._parseODataDuration(sValue);
	}

	return null;
};


module.exports = CalendarTime;